import { Image, List } from "antd-mobile"
import { useTranslation } from "react-i18next"
import FeedbackBtns from "../hotFaq/FeedbackBtns"
import ContactDialog from "../../../components/dialog/ContactDialog"
import { useRef } from "react"
import WechatDialog from "../../../components/dialog/WechatDialog"
import InstructionItems from "../Instruction/InstructionItems"
import { useNavigate } from "react-router-dom"

const ShootFaq = props => {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const contactDlgRef = useRef(null)
    const wechatDlgRef = useRef(null)

    const handleFeedback = () => {
        window.ReactNativeWebView.postMessage('feedback')
    }

    const handleContact = () => {
        contactDlgRef.current?.show()
    }
    return <div className="tab-content">
        <div style={{ background: 'white', borderRadius: 16 }}>
            <List mode='card'>
                <List.Item onClick={() => {
                    navigate('/shoot_un_connect')
                }}>
                    {t('shoot_item1')}
                </List.Item>
                <div className='seperate' />
                <List.Item onClick={() => {
                    navigate('/shoot_use')
                }}>
                    {t('shoot_item2')}
                </List.Item>
                <div className='seperate' />
                {/* <List.Item onClick={() => {
                    navigate('/gyroscope')
                }}>
                    {t('shoot_item3')}
                </List.Item> */}
                <div className='seperate' />
                <List.Item onClick={() => {
                    navigate('./charge_in_use')
                }}>
                    {t('shoot_item4')}
                </List.Item>
                <div className='seperate' />
                {/* <List.Item onClick={() => {
                    navigate('./pre_record')
                }}>
                    {t('shoot_item5')}
                </List.Item> */}
                <div className='seperate' />
                <List.Item onClick={() => {
                    navigate('/wide_angle')
                }}>
                    {t('shoot_item6')}
                </List.Item>
            </List>
        </div>

        <InstructionItems />
        <FeedbackBtns onFeedbackClick={handleFeedback} onContactClick={handleContact} />
        <ContactDialog ref={contactDlgRef} onPhoneClick={() => {
            window.ReactNativeWebView.postMessage('400-069-0588')
        }} onWechatClick={() => {
            contactDlgRef.current?.dismiss()
            wechatDlgRef.current?.show()
        }} />
        <WechatDialog ref={wechatDlgRef} />
    </div>
}

const styles = {
    cancat: {
        fontSize: 15,
        color: '#4C4C4CCC',
        fontWeight: '500'
    },
}

export default ShootFaq